import React, { Component } from 'react'
import classNames from "classnames";
import PropTypes from 'prop-types'
import { renderToStaticMarkup } from 'react-dom/server';
import withStyles from '@material-ui/core/styles/withStyles'
import { defaultFont } from '../../assets/material-kit-react'
import Header from '../../components/Header'
import Parallax from '../../components/Parallax/Parallax'
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Select from "@material-ui/core/Select"
import ScrollableAnchor from 'react-scrollable-anchor'
import Home from "./home/Home"
import Unit from "./units/Units"
import Location from "./location/Location"
import AboutUs from "./about_us/AboutUs"
import ContactUs from "./contact_us/ContactUs"
import * as Sentry from '@sentry/browser'
import { withLocalize } from 'react-localize-redux';
import globalTranslation from '../../localization/global';
import * as URL from '../../api/EndPoint';
// import {
//     BrowserView,
//     MobileView
// } from "react-device-detect"
// import asyncComponent from '../../components/hoc/asyncComponent'

Sentry.init({
    dsn: "https://a2a837fdcc7047ee8369a55e2f144948@sentry.io/1337446"
});

// const AsyncParallax = asyncComponent(() => {
//     return import ('../../components/Parallax/Parallax')
// })

// const AsyncHome = asyncComponent(() => {
//     return import ('./home/Home')
// })

// const AsyncUnit = asyncComponent(() => {
//     return import ('./units/Units')
// })

// const AsyncLocation = asyncComponent(() => {
//     return import ('./location/Location')
// })

// const AsyncAboutUs = asyncComponent(() => {
//     return import ('./about_us/AboutUs')
// })

// const AsyncContactUs = asyncComponent(() => {
//     return import('./contact_us/ContactUs')
// })


class ShareHolderLandingPage extends Component {

    constructor(props) {
        super(props)

        this.state = {
            redirect_to_login: false,
            select_language: 'en'
        }

        this.props.initialize({

            languages: [
                {
                    name: 'English',
                    code: 'en'
                },
                {
                    name: 'Myanmar (Zawgyi)',
                    code: 'mmzawgyi'
                },
                {
                    name: 'Myanmar (Unicode)',
                    code: 'mmunicode'
                }
            ],
            translation: globalTranslation,
            options: {
                renderToStaticMarkup
            },

        });

    }

    onChangeLanguage = event => {

        this.setState({
            select_language: event.target.value
        })

        this.props.setActiveLanguage(event.target.value)

    }

    componentDidCatch(error, errorInfo) {

        Sentry.withScope(scope => {
            Object.keys(errorInfo).forEach(key => {
                scope.setExtra(key, errorInfo[key]);
            });
            Sentry.captureException(error);
        });

    }

    render() {

        const { classes } = this.props
        // console.log("param: shareholder> ", this.props)
        // console.log("param: shareholder> ", this.props.location.search === "")

        return (

            <div className={classes.Main}>

                <Header
                    transparent
                    fixed
                    leftLinks={
                        <img className={classes.logo} src={require('../../images/logo.png')} alt="cityloft" />
                    }

                    rightLinks={
                        <List className={classes.list}>

                            <ListItem className={classes.listItem}>
                                <a href='#home' className={classes.navLink} > Home </a>
                            </ListItem>

                            <ListItem className={classes.listItem}>
                                <a href='#unit' className={classes.navLink} > Unit </a>

                            </ListItem>

                            <ListItem className={classes.listItem}>
                                <a href='#location' className={classes.navLink} > Location </a>
                            </ListItem>

                            <ListItem className={classes.listItem}>
                                <a href='#about-us' className={classes.navLink} > About Us </a>
                            </ListItem>

                            {/* <ListItem className={classes.listItem}>
                                <NavLink
                                    href="#pablo"
                                    className={classes.navLink}
                                    to={ROUTE_SIGN}
                                    //onClick={e => e.preventDefault()}
                                    color="transparent"
                                >
                                    Login
                                </NavLink>
                            </ListItem> */}

                            <ListItem className={classes.listItem} onClick={()=> this.openOwner()}> 
                                <div className={classes.navLink}> 
                                    Owner
                                </div>
                            </ListItem>

                            <ListItem className={classes.listItem}>
                                <a href='#contact-us' className={classes.contact_us} > Contact Us </a>
                            </ListItem>

                            <ListItem className={classes.listItem}>
                                <Select
                                    native
                                    className={classes.localization}
                                    value={this.state.select_language}
                                    onChange={this.onChangeLanguage}
                                    name="status"
                                    inputProps={{
                                        id: 'age-native-required',
                                    }}>
                                    {
                                        this.props.languages.map(langauge =>
                                            <option key={langauge.code} value={langauge.code}>
                                                {
                                                    langauge.name
                                                }
                                            </option>
                                        )
                                    }

                                </Select>
                            </ListItem>

                        </List>
                    }
                />

                <div className={classes.parallax}>
                    {/* <AsyncParallax image={"https://cdn.yomastrategic.net/cityloft/clus/1--Aerial-View-1--master-plan-update.jpg"}/> */}
                    {/* https://cdn.yomastrategic.net/cityloft/clus/master-plan-update.jpf */}
                    {/* https://s3-ap-southeast-1.amazonaws.com/cdn.yomastrategic.net/cityloft/clus/cl-master-plan-1600.jpg */}
                    {/*https://s3-ap-southeast-1.amazonaws.com/cdn.yomastrategic.net/cityloft/clus/master-plan-small.jpg */}
                    <Parallax 
                        image={"https://s3-ap-southeast-1.amazonaws.com/cdn.yomastrategic.net/cityloft/clus/cl-master-plan-1600.jpg"}>

                    </Parallax>

                    {/* <Parallax image={"https://cdn.yomastrategic.net/cityloft/clus/master-plan-last-update.jpg"}>

                    </Parallax> */}
                </div>

                <div className={classNames(classes.section, classes.sectionRaised)}>
                    <ScrollableAnchor id={'home'}>
                        {/* <AsyncHome/> */}
                        <Home />
                    </ScrollableAnchor>

                    <ScrollableAnchor id={'unit'}>
                        {/* <AsyncUnit/> */}
                        <Unit />
                    </ScrollableAnchor>

                    <ScrollableAnchor id={'location'}>
                        {/* <AsyncLocation/> */}
                        <Location/>
                    </ScrollableAnchor>
                    
                    <ScrollableAnchor id={'about-us'}>
                        {/* <AsyncAboutUs/> */}
                        <AboutUs/>
                    </ScrollableAnchor>

                    <ScrollableAnchor id={'contact-us'}>
                        <ContactUs param={this.props.location.search} />
                        {/* <AsyncContactUs param={this.props.location.search}/> */}
                    </ScrollableAnchor> 
                </div>

            </div>

        )
    }

    openOwner = () => {
        window.open(URL.OWNER);
    }

}

const styles = theme => ({
    main: {
        width: "100%",
        height: "100vh",
    },
    parallax: {
        marginTop: "75dp",
        paddingTop: "75dp"
    },
    logo: {
        width: '150px',
    },
    list: {
        ...defaultFont,
        fontSize: "14px",
        margin: 0,
        paddingLeft: "0",
        listStyle: "none",
        paddingTop: "0",
        paddingBottom: "0",
        color: "inherit"
    },
    listItem: {
        float: "left",
        color: "inherit",
        position: "relative",
        display: "block",
        width: "auto",
        margin: "5px",
        padding: "0",
        cursor: 'pointer',
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            "&:after": {
                width: "calc(100% - 30px)",
                content: '""',
                display: "block",
                height: "1px",
                marginLeft: "15px",
                backgroundColor: "#fde70c"
            }
        }
    },
    navLink: {
        color: "inherit",
        position: "relative",
        padding: "0.9375rem",
        fontWeight: "400",
        fontSize: "16px",
        textTransform: "none",
        borderRadius: "10px",
        lineHeight: "12px",
        textDecoration: "none",
        margin: "0px",
        display: "inline-flex",
        "&:hover,&:focus": {
            color: "#000000",
            background: "rgb(253,231,12)",
        },
        [theme.breakpoints.down("sm")]: {
            width: "calc(100% - 30px)",
            marginLeft: "15px",
            marginBottom: "8px",
            marginTop: "8px",
            textAlign: "left",
            "& > span:first-child": {
                justifyContent: "flex-start"
            }
        }
    },
    
    contact_us: {
        position: "relative",
        padding: "0.9375rem",
        fontWeight: "400",
        fontSize: "16px",
        textTransform: "none",
        borderRadius: "10px",
        lineHeight: "12px",
        textDecoration: "none",
        margin: "0px",
        display: "inline-flex",
        color: "#000000",
        background: "rgb(253,231,12)",
        [theme.breakpoints.down("sm")]: {
            width: "calc(100% - 30px)",
            marginLeft: "15px",
            marginBottom: "8px",
            marginTop: "8px",
            textAlign: "left",
            "& > span:first-child": {
                justifyContent: "flex-start"
            }
        }
    },
    localization: {
        position: "relative",
        marginLeft: "10px",
        display: "inline-flex",
        [theme.breakpoints.down("sm")]: {
            width: "calc(100% - 30px)",
            marginLeft: "15px",
            marginBottom: "8px",
            marginTop: "8px",
            textAlign: "left",
            "& > span:first-child": {
                justifyContent: "flex-start"
            }
        }
    },
    section: {
        paddingTop: "10px",
        position: "relative",
        background: "#FFFFFF",
        zIndex: "3",
    }
    ,sectionRaised: {
        borderRadius: "3px",
        background: "#FFFFFF",
    },

})

ShareHolderLandingPage.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withLocalize(withStyles(styles)(ShareHolderLandingPage))